<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            float: left;
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 30px;
            margin-left: 3px;
            letter-spacing: 2px;
          "
        >
          行情分析工具
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
            <li class="pli" v-for="(item,index) in leftnav" :key="index">
                <div v-bind:class="[item.active ? class4 : class3]"></div>
                <div v-bind:class="[item.active ? class1 : class5]" @click="show(index)">
                    <div style="width: 45px; height: 40px; float: left"></div>
                    <div class="tagmid">{{item.text}}</div>
                    <div style="width: 30px; height: 40px; float: left"></div>
                </div>
                <div style="width: 9px; height: 7px; float: left;position:absolute;right:1px;bottom:-7px">
                    <img
                        src="../../assets/images/lan-jia.png"
                        style="display: block"
                        v-if="item.active"
                    />
                </div>
            </li>
        </ul>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="leftnav.filter((el)=>{return el.id=='kzfx'})[0].active">
              <h4 class="head4" id="productcentertwo">二、扩展分析</h4>
              <p class="pproduct">
                回归分析：根据K线图数据精确计算合约的相关性和线性关系，并提供散点图、回归方程、Beta、Alpha、R^2等专业统计指标，以进行价格预测、套利可行性检验等分析；
              </p>
              <p class="pproduct">
                波动率分析：基于历史数据统计短期和长期波动率指标，假设未来是历史的延伸，利用历史估计未来价格波动率，判断交易机会；
              </p>
              <p class="pproduct">
                季节性分析：按月记录合约价格趋势和涨幅并逐年横向对比，研究商品的周期性，掌握合约价格波动周期，提前部署交易计划；
              </p>
              <p class="pproduct">
                期货横截面：由不同交割月份合约的价格按照到期时间先后串联组成远期价格曲线，反应合约远期价格趋势。
              </p>
              <p class="pproduct">
                期现链：提供现货历史价格走势和距离交割日不同周期的价格点位标记，直观分析何时入场持有到期更加合理。
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='xhsj'})[0].active">
              <h4 class="head4" id="productcenterthree">
                三、k线图叠加现货数据
              </h4>
              <p class="pproduct">
                连续的现货数据线形展示，与相同品种期货K线叠加，让期现价差一目了然。
              </p>
              <p class="pproduct">
                提供的现货数据包括：国内主要现货市场价格、全球品种供需数据、国家海关进出口数据、国内外交易所库存、CFTC统计的持仓数据。
              </p>
              <p class="pimg"><img src="@/../public/proimg/djxhsj.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='qsxyj'})[0].active">
              <h4 class="head4" id="productcenterfour">四、云端趋势线预警</h4>
              <p class="pproduct">
                画线分析后不必盯盘，价格碰触趋势线自动预警。电脑关机状态下，当满足触发条件时可在手机上收到预警。
              </p>
              <p class="pproduct">
                线型支持：趋势线、射线、水平线、线段、通道线、矩形、三角形、甘氏线、阻速线、线型回归带、回归通道、黄金率、百分比线、波浪尺、量度目标。
              </p>
              <p class="pproduct">本功能只支持国内期货合约。</p>
              <p class="pimg"><img src="@/../public/proimg/qsxyj_4.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='gsyj'})[0].active">
              <h4 class="head4" id="productcenterfive">五、云端公式预警</h4>
              <p class="pproduct">
                自定义预警公式，云端存储。针对国内期货合约设置云端预警条件，当条件满足时即使电脑是关闭状态，也会在手机上收到提醒。
              </p>
              <p class="pimg"><img src="@/../public/proimg/gsyj.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='yjdp'})[0].active">
              <h4 class="head4" id="productcentersix">一、一机多屏</h4>
              <p class="pproduct">
                一机多屏是wh7特有的功能，可将自设页面分屏到其他多个屏幕上，同时查看更多的合约，更多的指标，更多画线分析。
              </p>
              <p class="pproduct">
                多个屏幕页面，加载多个预警公式/交易模型，自动闪屏提示，盘面信号变动一目了然。
              </p>
              <p class="pimg"><img src="@/../public/proimg/picp4-wh7.png" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='nczl'})[0].active">
              <h4 class="head4" id="productcenterseven">六、页面内存驻留</h4>
              <p class="pproduct">
                自设页面驻留内存，切换页面不需要再申请数据，瞬间完成。
              </p>
              <p class="pimg"><img src="@/../public/proimg/ymqh4.gif" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='tsgn'})[0].active">
              <h4 class="head4" id="productcentereleven">
                七、股票相关特色功能
              </h4>
              <p class="pproduct">
                股票板块地图：按行业和地域分类显示板块地图，可直观观察板块涨跌。
              </p>
              <p class="pproduct">
                公式选股：在全市场范围内，根据K线形态、指标、盘面行情、财务数据等数据，选出满足条件的股票。
              </p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftnav:[{active:true,text:'一机多屏',id:'yjdp'},
      {active:false,text:'扩展分析',id:'kzfx'},
      // {active:false,text:'产业数据',id:'cysj'},
      {active:false,text:'k线图叠加现货数据',id:'xhsj'},
      {active:false,text:'云端趋势线预警',id:'qsxyj'},
      {active:false,text:'云端公式预警',id:'gsyj'},
      {active:false,text:'页面内存驻留',id:'nczl'},
      {active:false,text:'股票相关特色功能',id:'tsgn'}],
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    show(index){
        console.log()
        this.leftnav.forEach((el,idx)=>{
            el.active=false
        })
        this.leftnav[index].active=true
    },
    custormAnchor(anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      console.log(anchorElement.scrollTop)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },
   
  },
  mounted(){
    this.leftnav.forEach((el,idx)=>{
            el.active=false
    })
    this.leftnav.filter((el)=>{
      return el.id==this.$route.params.id
    })[0].active=true
    this.$nextTick(()=>{

      this.custormAnchor(this.$route.hash.split('#')[1]);
    })
  }

};
</script>

<style scoped>
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 105px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 476px;
  border-radius: 2%;
  background: url("../../assets/images/ts-1_01_brown.png") no-repeat center;
  /* background-size: 100% 100%; */
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
  z-index: 999;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #2f5476;
  letter-spacing: 1px;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #702a13;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #245376;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #e3a200;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #963d20;
  color: #ffcbba;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.pli:last-child .noclickone{
  border-bottom: 1px solid #963d20;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 130px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>